import React from "react";
import { Route } from "react-router-dom";
import ResumenSocio from "../../pages/resumenGeneral/ResumenGeneralSocio";
import PagoServicio from "../../pages/pagoServicios/PagoServicio";
import PagoServicioCabal from "../../pages/pagoServiciosSicoop/PagoServicioCabal";
import AdquisicionRueda from "../../pages/rueda/AdquisicionRueda";
import PinTransaccional from "../../pages/login/PinTransaccional";
import PinAcceso from "../../pages/login/pinAcceso";
import TransferenciaInterbancaria from "../../pages/transferencias/bancaria/TransferenciaInterbancaria";
import TransferCuentasTerceros from "../../pages/transferencias/cuentasTerceros/TransferCuentasTerceros";
import TransferCuentasPropias from "../../pages/transferencias/cuentasPropias/TransferCuentasPropias";
import SolicitudPrestamo from "../../pages/solicitudes/Prestamo";
import SolicitudTarjeta from "../../pages/solicitudes/TarjetaCredito";
import SolicitudTarjetaDebito from "../../pages/solicitudes/TarjetaDebito";
import SolicitudAumentoTC from "../../pages/solicitudes/AumentoTC";
import SolicitudSubsidios from "../../pages/solicitudes/Subsidios/Subsidio";
import AgregarSubsidio from "../../pages/solicitudes/Subsidios/AgregarSubsidio";
import ModificarSubsidio from "../../pages/solicitudes/Subsidios/ModificarSubsidio";
import SuscripcionExtractoTC from "../../pages/autogestion/suscripcionExtractos/SuscripcionExtractoTC";
import HabilitarCuenta from "../../pages/autogestion/cuentas/HabilitarCuenta";
import SuscripcionAlerta from "../../pages/Alerta/SuscripcionAlerta";
import PagoAporte from "../../pages/PagoObligacionSocietaria/aporte/PagoAporte";
import PagoSolidaridad from "../../pages/PagoObligacionSocietaria/solidaridad/PagoSolidaridad";
import PagoTarjeta from "../../pages/pagoTarjeta/PagoTarjeta";
import PagoPrestamo from "../../pages/pagoPrestamo/PagoPrestamo";
import ModifFechaVtoCredito from '../../pages/ModifFechaVtoCredito/ModifFechaVtoCredito.jsx';

import Pronet from "../../pages/pagoServicios/PronetPago";
import Sicoop from "../../pages/pagoServiciosSicoop/SicoopPago";

import DatosPersonales from "../../pages/datosPersonales/DatosPersonales";
import SolicitudPinTransaccional from "../../pages/pinTrasaccional/solicitud/SolicitudPinTransaccional";
import CambioClave from "../../pages/datosPersonales/CambiarClave";
import CambioPinTransaccional from "../../pages/pinTrasaccional/CambiarPinTransaccional";
import InactivarPinTransaccional from "../../pages/pinTrasaccional/InactivarPinTransaccional.js";
import DebitoAutomatico from "../../pages/autogestion/debitoAutomatico/DebitoAutomatico";
import AgregarDebito from "../../pages/autogestion/debitoAutomatico/AgregarDebito";
import AgregarAlerta from "../../pages/Alerta/AgregarAlerta";
import ActividadEducacion from "../../pages/actividadEducacion/ActividadEducacion";
import Cupones from "../../pages/consulta/Cupones";
import Excedentes from "../../pages/consulta/Excedente";
import Padron from "../../pages/consulta/Padron";
import MovimientoCuenta from "../../pages/consulta/MovimientoCuenta";
import ExtractoTarjeta from "../../pages/consulta/ExtractoTarjeta";
import Factura from "../../pages/consulta/Factura";
import PagoServicioComprobante from "../../pages/consulta/PagoServicioComprobante";
import TransferenciaInterbancariaComprobante from "../../pages/consulta/TransferenciaInterbancariaComprobante";
import ExtractoTC from "../../pages/consulta/ExtractoTC";
import SolicitudPrestamoPreaprobado from "../../pages/solicitudes/PrestamoPreaprobado";
import PagoQr from "../../pages/consulta/PagoQr";
import OperacionesQR from "../../pages/consulta/OperacionesQR";
import TransferenciaXpress from "../../pages/transferencias/transferenciaXpress/TransferenciaXpress";
import TransferenciaXpressComprobante from "../../pages/consulta/TransferenciaXpressComprobante";
import TransferenciaCuentaTerceroComprobante from "../../pages/consulta/TransferenciaCuentaTerceroComprobante";
import Login from "../../pages/login/login";
import Sugerencias from "../../pages/sugerencias/Sugerencias";
import EmpresaConvenio from "../../pages/convenios/EmpresasConvenio";
import SucursalesCercanas from "../../pages/sucursalesCercanas/SucursalesCercanas";
import FlyerEmpresa from "../../pages/convenios/FlyerEmpresa.js";
import ExtractoPanalCabal from "../../pages/consulta/ExtractoPanalCabal";
import ConfigurarTarjeta from "../../pages/autogestion/configurarTarjeta/ConfigurarTarjeta";
import ConfigurarTarjetaCabal from "../../pages/autogestion/configurarTarjetaCabal/ConfigurarTarjetaCabal";
import TransferenciaInterentidad from "../../pages/transferencias/interentidades/TransferenciaInterentidad";
import TransferenciaInterentidadComprobante from "../../pages/consulta/TransferenciaInterentidadComprobante";
import AhorroProgramadoComprobante from "../../pages/consulta/AhorroProgramadoComprobante";
import PagosPix from "../../pages/consulta/PagosPix";
import TransferenciaQrEnviar from "../../pages/operacionesQR/TransferenciaQrEnviar/TransferenciaQrEnviar";
import TransferenciaQrPedir from "../../pages/operacionesQR/TransferenciaQrPedir/TransferenciaQrPedir";
import PagoDepositoExtraccionQr from "../../pages/operacionesQR/PagoDepositoExtraccionQr/PagoDepositoExtraccionQr";
import FacturaElectronica from "../../pages/consulta/FacturaElectronica";
import { PagoSepelio } from "../../pages/PagoObligacionSocietaria/sepelio/PagoSepelio";
import HabilitarAhorroProgramado from "../../pages/autogestion/ahorroProgramado/HabilitarAhorroProgramado";
import { RuedasComprobante } from "../../pages/consulta/RuedasComprobante";
import { PagoServicioCabalComprobante } from "../../pages/consulta/PagoServicioCabalComprobante.js";
//import BloqueoCuenta from "../../pages/autogestion/bloqueo/BloqueoCuenta";
import  CrearPinVirtual  from "../../pages/autogestion/pinVirtual/CrearPinVirtual";
import PerfilTransaccional from "../../pages/consulta/PerfilTransaccional.js";

import  PrestamoInmediato  from "../../pages/autogestion/prestamoInmediato/PrestamoInmediato.js";
import MisCompras from "../../pages/MisCompras/MisCompras";
import SimuladorAhorros from "../../pages/consulta/SimuladorAhorros";
import TuMetaEsLaNuestra from "../../pages/autogestion/tuMetaEsLaNuestra/HabilitarTuMetaEsLaNuestra.js";
import Alias from "../../pages/transferencias/alias/Alias.js";




export const componentes = {
    pinTransaccional: <PinTransaccional />,
    pinAcceso: <PinAcceso />,
    resumenGeneralSocio: <ResumenSocio />,
    transferCuentasPropias: <TransferCuentasPropias />,
    transferCuentasTerceros: <TransferCuentasTerceros />,
    transferInterbancaria: <TransferenciaInterbancaria />,
    transferXpress: <TransferenciaXpress />,
    pagoAporte: <PagoAporte />,
    pagoSolidaridad: <PagoSolidaridad />,
    pagoTarjeta: <PagoTarjeta />,
    pagoPrestamo: <PagoPrestamo />,
    pagoServicio: <PagoServicio />,
    pagoServicioCabal: <PagoServicioCabal />,
    pronet: <Route exact path="/pronet" component={Pronet} />,
    cabal: <Route exact path="/cabal" component={Sicoop} />,
    actividadEducacion: <ActividadEducacion />,
    adquisicionRueda: <AdquisicionRueda />,
    solicitudPinTransaccional: <SolicitudPinTransaccional />,
    cambioPinTransaccional: <CambioPinTransaccional />,
    solicitudPrestamo: <SolicitudPrestamo />,
    solicitudPrestamoPreaprobado: <SolicitudPrestamoPreaprobado />,
    solicitudTarjeta: <SolicitudTarjeta />,
    solicitudTarjetaDebito: <SolicitudTarjetaDebito />,
    solicitudAumentoTC: <SolicitudAumentoTC />,
    solicitudSubsidios: <SolicitudSubsidios />,
    agregarSubsidio: <AgregarSubsidio />,
    modificarSubsidio: <ModificarSubsidio />,
    suscripcionExtractoTC: <SuscripcionExtractoTC />,
    habilitarCuenta: <HabilitarCuenta />,
    debitoAutomatico: <DebitoAutomatico />,
    agregarDebito: <AgregarDebito />,
    agregarAlerta: <AgregarAlerta />,
    suscripcionAlerta: <SuscripcionAlerta />,
    cupones: <Cupones />,
    excedentes: <Excedentes />,
    padron: <Padron />,
    movimientoCuenta: <MovimientoCuenta />,
    extractoTarjeta: <ExtractoTarjeta />,
    extractoTC: <ExtractoTC />,
    extractoPanalCabal: <ExtractoPanalCabal />,
    factura: <Factura />,
    facturaElectronica: <FacturaElectronica />,
    pagoQR: <PagoQr />,
    operacionesQR: <OperacionesQR />,
    pagoServicioComprobante: <PagoServicioComprobante />,
    pagoServicioCabalComprobante: <PagoServicioCabalComprobante />,
    transferenciaCuentaTerceroComprobante: <TransferenciaCuentaTerceroComprobante />,
    transferenciaInterbancariaComprobante: <TransferenciaInterbancariaComprobante />,
    transferenciaXpressComprobante: <TransferenciaXpressComprobante />,
    datosPersonales: <DatosPersonales />,
    cambioClave: <CambioClave />,
    login: <Login />,
    sugerencias: <Sugerencias />,
    convenios: <EmpresaConvenio />,
    sucursalesCercanas: <SucursalesCercanas />,
    flyerEmpresa: <FlyerEmpresa />,
    configurarTarjeta: <ConfigurarTarjeta />,
    configurarTarjetaCabal: <ConfigurarTarjetaCabal />,
    transferInterentidad: <TransferenciaInterentidad />,
    transferenciaInterentidadComprobante: <TransferenciaInterentidadComprobante />,
    ahorroProgramadoComprobante: <AhorroProgramadoComprobante />,
    pagosPix: <PagosPix/>,
  //  ahorroProgramadoComprobante: <Route exact path="/ahorroProgramado" component={AhorroProgramadoComprobante} />,

   //ahorroProgramadoComprobante: <AhorroProgramadoMetaComprobante />,

    transferenciaQrEnviar: <TransferenciaQrEnviar />,
    transferenciaQrPedir: <TransferenciaQrPedir />,
    pagoDepositoExtraccion: <PagoDepositoExtraccionQr />,
    pagoSepelio: <PagoSepelio />,
    habilitarAhorroProgramado: <HabilitarAhorroProgramado />,
    ruedasComprobante: <RuedasComprobante />,
    inactivarPinTransaccional: <InactivarPinTransaccional/>,
    crearPinVirtual: <Route exact path="/crearPinVirtual" component={CrearPinVirtual} />,
    MisCompras: <Route exact path="/misCompras" component={MisCompras} />,
    perfilTransaccional: <PerfilTransaccional/>,
    // prestamoInmediato: <PrestamoInmediato/>,
    prestamoInmediato: <Route exact path="/prestamoInmediato" component={PrestamoInmediato} />,
    simuladorAhorros: <SimuladorAhorros />,
    tuMetaEsLaNuestra: <TuMetaEsLaNuestra />,
    alias: <Alias/>,
    modificacionFechaVencimiento : <ModifFechaVtoCredito />

    // bloqueoCuenta: <BloqueoCuenta/>
};